/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_07_LabelInputs */

const en_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Governance`)
};

const de_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Governance`)
};

const fr_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const es_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const it_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const nl_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const pl_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const fi_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const da_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const sv_landing_section_07_label = /** @type {(inputs: Landing_Section_07_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

/**
* | output |
* | --- |
* | "AI Governance" |
*
* @param {Landing_Section_07_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_07_label = /** @type {((inputs?: Landing_Section_07_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_07_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_07_label(inputs)
	if (locale === "fr") return fr_landing_section_07_label(inputs)
	if (locale === "es") return es_landing_section_07_label(inputs)
	if (locale === "it") return it_landing_section_07_label(inputs)
	if (locale === "nl") return nl_landing_section_07_label(inputs)
	if (locale === "pl") return pl_landing_section_07_label(inputs)
	if (locale === "fi") return fi_landing_section_07_label(inputs)
	if (locale === "da") return da_landing_section_07_label(inputs)
	if (locale === "sv") return sv_landing_section_07_label(inputs)
	return en_landing_section_07_label(inputs)
});